/** @format */
import { Product, ProductConditionValue } from '@toucan/client/global/product';

import { BasketProductState } from './constants';

export type BasketProductAttribute = {
    name: string;
    value: string;
};

type BasketProductExtraInfo = {
    modelSlug: string;
    attributes: BasketProductAttribute[];
    department: string;
    __meta: any;
};

// this is returned from the basket API
export type MPBXBasketProduct = BasketProductExtraInfo &
    Omit<BasketProduct, 'condition'> & {
        condition: string;
    };

export type BasketProductImage = {
    alt: string;
    url: string | null;
    product: string;
    image: string;
    imageUrl: string;
    thumb: string;
    ordering: number;
    meta?: any;
};

export type BasketProduct = {
    id: number;
    modelId: number;
    productId?: number;
    sku: string;
    fullSku: string;
    name: string;
    images: BasketProductImage[];
    condition: ProductConditionValue;
    state: BasketProductState;
    listPrice: string;
    modelName: string;
    value?: number;
    isSold: boolean;
    modelSlug: string;
    department: string;
};

export type GetBasketOptions = { useCachedPrices: boolean };

export type AddToBasketProduct = Pick<
    Product,
    'id' | 'modelId' | 'sku' | 'name' | 'condition' | 'value' | 'image'
>;

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface Basket {
    items: BasketItem[];
    codes?: string[];
    currency?: string;
}

export enum BasketItemAvailability {
    AVAILABLE = 'Available',
    UNAVAILABLE = 'Unavailable',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface BasketItem {
    product: BasketProduct;
    availability: BasketItemAvailability;
    itemImage: {
        '36x36': string;
        '200x200': string;
        '1000x800': string;
    };
    sku: string;
    department: string;
    listPrice: string;
    currency: string;
    taxScheme: string[];
    /**
     * @deprecated
     * We shouldn't use this as the basket service uses legacy tax calculations
     */
    priceExTax?: string;
    /**
     * @deprecated
     * We shouldn't use this as the basket service uses legacy tax calculations
     */
    priceIncTax?: string;
}
